import * as React from 'react';

import { TextField } from '@emburse/ui-core';

interface ICurrencyInputProps {
  className?: string;
  value?: number;
  min?: number;
  max?: number;
  errorMessage?: string;
  onChange?: (val: number) => void;
}

export const CurrencyInput: React.FC<ICurrencyInputProps> = ({ className, value = '', min, max, errorMessage, onChange }) => (
  <TextField
    label="Budget"
    id="budget-input"
    name="budget-input"
    type="number"
    fullWidth
    required
    helperText={errorMessage}
    error={Boolean(errorMessage)}
    value={value && value.toString()}
    endAdornment={window.USER.currency_code}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
      if (!onChange) {
        return;
      }
      const newVal = e.target.value;
      // Only allow numbers and decimal point
      if (newVal === '' || /^\d+\.?\d{0,2}$/.test(newVal)) {
        onChange(Number(e.target.value));
      }
    }}
    onWheel={(e: React.WheelEvent<Element>) => (e.target as HTMLInputElement).blur()}
    inputProps={{ min: min || 0, max: max || Infinity, step: '0.01' }}
  />
);
